function getFilenameFromDisposition(disposition: string | null): string | undefined {
    if (disposition == null) {
        return;
    }

    // Try to match filename* (RFC 5987) for UTF-8
    let matches = /filename\*\s*=\s*UTF-8''([^;\n]*)/i.exec(disposition);

    if (matches && matches[1]) {
        return decodeURIComponent(matches[1]);
    }

    // Fallback to regular filename
    matches = /filename\s*=\s*("?)([^";\n]+)\1/i.exec(disposition);

    if (matches && matches[2]) {
        return matches[2];
    }
}

// ----------------------------------------------------------------------------

export default getFilenameFromDisposition;
